(function() {
    angular
        .module("devicesModule")
        .controller("DeviceTrackerController", DeviceTrackerController)

    DeviceTrackerController.$inject = [
        "$rootScope",
        "$scope",
        "$filter",
        "$state",
        "$stateParams",
        "$uibModal",
        "prefs",
        "devicesService",
        "trackersService",
        "telemetryService",
        "historyService",
        "customersService",
        "googleMapsService",
        "userMessagingService",

    ]

    function DeviceTrackerController(
        $rootScope,
        $scope,
        $filter,
        $state,
        $stateParams,
        $uibModal,
        prefs,
        devicesService,
        trackersService,
        telemetryService,
        historyService,
        customersService,
        googleMapsService,
        userMessagingService,
    ){
        "use strict"

        document.body.scrollTop = document.documentElement.scrollTop = 0

        $rootScope.title = "Tracker Details | WANCO"

        $scope.loading         = true
        $scope.details_tab     = "details"
        $scope.deviceSummaries = []
        $scope.trackers        = []
        $scope.tracker         = {}

        $scope.gpsHistory           = []
        $scope.gpsHistoryFiltered   = []
        $scope.gpsHistoryMaxRecords = 700

        $scope.isRequesting = false

        $scope.geofenceFormData = {}
        $scope.editGeofence     = false
        $scope.hasGeofence      = false

        $scope.retrievedTracker = false

        $scope.showBreadCrumbs = prefs.get().tracker.showBreadcrumbs

        $scope.bearingName = "Unknown"

        $scope.units = [
            {unit:"mi", label: "mi"},
            {unit:"km", label: "km"}
        ]

        let map = undefined

        const updateBreadCrumbs = () => {
            let connectCurrent = true
            let gpsHistory = $scope.showBreadCrumbs === true ? $scope.gpsHistory : []
            if (gpsHistory.length > 0 && $scope.bcFilter.isApplied) {
                gpsHistory = $scope.gpsHistoryFiltered
                gpsHistory.splice(0, 0, $scope.gpsHistory[0])
                connectCurrent = false
            }

            if (map === undefined) {
                googleMapsService.createMap("mapConstruct").then((mapObject) => {
                    map = mapObject
                    googleMapsService.setSingleMarker(true, map, $scope.tracker, gpsHistory, connectCurrent)
                    googleMapsService.setGeofence(map, $scope.tracker)
                })
            } else {
                googleMapsService.setSingleMarker(false, map, $scope.tracker, gpsHistory, connectCurrent)
                googleMapsService.setGeofence(map, $scope.tracker)
            }
        }

        const beaconTrailerDefaultScheduleTime = (value, isStart) => {
            if (value === undefined || value === null) {
                let todaysDate = $rootScope.presentDateTime(new Date(), "NumericShortDate", $scope.tracker.device.timezone_iana)
                todaysDate += " " + (isStart ? "09:00" : "17:00")
                value = moment.tz(todaysDate, $scope.tracker.device.timezone_iana).toISOString(true)
            }
            return $rootScope.presentDateTime(value, "NumericShortDate", $scope.tracker.device.timezone_iana) + value.slice(10)
        }

        const beaconTrailerCheckNextDays = () => {

            $scope.beaconTrailerSchedule1NextDay = false
            $scope.beaconTrailerSchedule2NextDay = false

            const schedule1StartHour = Number($rootScope.presentDateTime($scope.tracker.beacon_trailer.schedule_start_time_1, "TimeHour", $scope.tracker.device.timezone_iana))
            const schedule1EndHour   = Number($rootScope.presentDateTime($scope.tracker.beacon_trailer.schedule_end_time_1, "TimeHour", $scope.tracker.device.timezone_iana))

            if (schedule1StartHour > schedule1EndHour) {

                $scope.beaconTrailerSchedule1NextDay = true

            } else if (schedule1StartHour === schedule1EndHour) {

                const schedule1StartMinute = Number($rootScope.presentDateTime($scope.tracker.beacon_trailer.schedule_start_time_1, "TimeMinute", $scope.tracker.device.timezone_iana))
                const schedule1EndMinute   = Number($rootScope.presentDateTime($scope.tracker.beacon_trailer.schedule_end_time_1, "TimeMinute", $scope.tracker.device.timezone_iana))

                $scope.beaconTrailerSchedule1NextDay = schedule1StartMinute >= schedule1EndMinute

            }

            const schedule2StartHour = Number($rootScope.presentDateTime($scope.tracker.beacon_trailer.schedule_start_time_2, "TimeHour", $scope.tracker.device.timezone_iana))
            const schedule2EndHour   = Number($rootScope.presentDateTime($scope.tracker.beacon_trailer.schedule_end_time_2, "TimeHour", $scope.tracker.device.timezone_iana))

            if (schedule2StartHour > schedule2EndHour) {

                $scope.beaconTrailerSchedule2NextDay = true

            } else if (schedule2StartHour === schedule2EndHour) {

                const schedule2StartMinute = Number($rootScope.presentDateTime($scope.tracker.beacon_trailer.schedule_start_time_2, "TimeMinute", $scope.tracker.device.timezone_iana))
                const schedule2EndMinute   = Number($rootScope.presentDateTime($scope.tracker.beacon_trailer.schedule_end_time_2, "TimeMinute", $scope.tracker.device.timezone_iana))

                $scope.beaconTrailerSchedule2NextDay = schedule2StartMinute >= schedule2EndMinute

            }
        }

        const updateDisplay = () => {

            if ($scope.tracker.telemetry.hasOwnProperty("voltage_battery") && $scope.tracker.telemetry.voltage_battery > 0) {
                $scope.battery_health = telemetryService.getBatteryHealth($scope.tracker.telemetry.voltage_battery, $scope.tracker.system_voltage)
            } else if ($scope.tracker.telemetry.hasOwnProperty("voltage")) {
                $scope.battery_health = telemetryService.getBatteryHealth($scope.tracker.telemetry.voltage, $scope.tracker.system_voltage)
            }
            if ($scope.tracker.telemetry.hasOwnProperty("bearing") && $scope.tracker.telemetry.bearing !== undefined && $scope.tracker.telemetry.bearing.hasOwnProperty("degrees")) {
                let hasSetBearing = false
                if ($scope.tracker.meta.isTrackerRCUArrowBoard && $scope.tracker.telemetry.display.stowed) {
                    if ($scope.tracker.telemetry.bearing.degrees != 361) {
                        $scope.bearingName = "Unknown"
                    } else {
                        $scope.bearingName = "N/A (Display Stowed)"
                    }
                    hasSetBearing = true
                }
                if (!hasSetBearing) {
                    $scope.bearingName = $rootScope.getBearingName($scope.tracker.telemetry.bearing.degrees)
                }
            }
            if ($scope.tracker.initialized) {
                updateBreadCrumbs()
            }
            if ($scope.tracker.gps.geofence_radius !== null && $scope.tracker.gps.geofence_radius !== undefined) {
                $scope.geofenceFormData.geofence_center_lat = $scope.tracker.gps.geofence_center_lat
                $scope.geofenceFormData.geofence_center_lon = $scope.tracker.gps.geofence_center_lon
                $scope.geofenceFormData.geofence_radius     = $scope.tracker.gps.geofence_radius
                $scope.geofenceFormData.geofence_units      = $scope.tracker.gps.geofence_units
                $scope.hasGeofence = true
            }

            if ($scope.tracker.meta.isTrackerBeaconTrailer) {

                // const start_1 = $scope.tracker.beacon_trailer.schedule_start_time_1
                // const start_2 = $scope.tracker.beacon_trailer.schedule_start_time_2
                // const end_1   = $scope.tracker.beacon_trailer.schedule_end_time_1
                // const end_2   = $scope.tracker.beacon_trailer.schedule_end_time_2

                // if (start_1) {
                //     $scope.tracker.beacon_trailer.schedule_start_time_1 = $rootScope.presentDateTime(start_1, "NumericShortDate", $scope.tracker.device.timezone_iana) + start_1.slice(10)
                // } else {
                //     $scope.tracker.beacon_trailer.schedule_start_time_1 = $rootScope.presentDateTime(beaconTrailerDefaultScheduleTime(tracker, true), "NumericShortDate", $scope.tracker.device.timezone_iana) + start_1.slice(10)
                // }


                $scope.tracker.beacon_trailer.schedule_start_time_1 = beaconTrailerDefaultScheduleTime($scope.tracker.beacon_trailer.schedule_start_time_1, true)
                $scope.tracker.beacon_trailer.schedule_start_time_2 = beaconTrailerDefaultScheduleTime($scope.tracker.beacon_trailer.schedule_start_time_2, true)
                $scope.tracker.beacon_trailer.schedule_end_time_1   = beaconTrailerDefaultScheduleTime($scope.tracker.beacon_trailer.schedule_end_time_1, false)
                $scope.tracker.beacon_trailer.schedule_end_time_2   = beaconTrailerDefaultScheduleTime($scope.tracker.beacon_trailer.schedule_end_time_2, false)

                beaconTrailerCheckNextDays()

            }

            updateSolarLightTowerStatus()
            updateAFADDisplay()

        }

        const updateSolarLightTowerStatus = () => {

            if ($scope.tracker.meta.isTrackerSolarLightTower) {

                let svg = SOLAR_LIGHT_TOWER_STATUS_SVG

                // $scope.tracker.telemetry.victron_solar_watts = 166
                // $scope.tracker.telemetry.victron_battery_voltage = 59.2
                // $scope.tracker.telemetry.victron_battery_current = 2

                const solarWatts   = $scope.tracker.telemetry.victron_solar_watts
                const batteryWatts = $scope.tracker.telemetry.victron_battery_voltage * $scope.tracker.telemetry.victron_battery_current

                // According to Ken's Victron test
                const dcLoad = Math.abs(Math.round((solarWatts - batteryWatts) * 100) / 100)
                // Seems Better
                // const dcLoad       = Math.round(Math.abs(Math.min(0, $scope.tracker.telemetry.victron_solar_watts - Math.abs(batteryWatts))) * 100) / 100
                // const dcLoad       = Math.round(Math.max(0, Math.abs(batteryWatts) - $scope.tracker.telemetry.victron_solar_watts ) * 100) / 100

                svg = svg.replace("---VSY---", Math.round(solarWatts * 100) / 100)
                svg = svg.replace("---VDL---", dcLoad)
                svg = svg.replace("---VBP---", Math.round($scope.tracker.telemetry.victron_soc))

                svg = svg.replace("---VBT---", Math.round($scope.tracker.telemetry.victron_battery_temperature))
                svg = svg.replace("---VBV---", Math.round($scope.tracker.telemetry.victron_battery_voltage * 100) / 100)
                svg = svg.replace("---VBC---", Math.round($scope.tracker.telemetry.victron_battery_current * 10) / 10)
                svg = svg.replace("---VBW---", Math.round($scope.tracker.telemetry.victron_battery_voltage * $scope.tracker.telemetry.victron_battery_current * 100) / 100)

                svg = svg.replace("---DATE---", $rootScope.presentDateTime($scope.tracker.telemetry.updated_at, "TextMediumDate", $scope.tracker.device.timezone_iana))

                const solarActive = $scope.tracker.telemetry.victron_solar_watts > 0

                svg = svg.replace("---CHG---",  solarActive ? "visible" : "hidden")
                // Seems better
                // svg = svg.replace("---CHG---",  solarActive && dcLoad === 0 ? "visible" : "hidden")
                svg = svg.replace("---ACS1---", solarActive ? "hidden" : "visible")
                svg = svg.replace("---ACS2---", solarActive ? "visible" : "hidden")

                const dcLoadActive = dcLoad > 0

                svg = svg.replace("---ACD1---", dcLoadActive ? "hidden" : "visible")
                svg = svg.replace("---ACD2---", dcLoadActive ? "visible" : "hidden")

                setTimeout(() => {

                    $scope.$apply(() => {

                        const container = document.getElementById("sltStatusContainer")

                        if (container !== null && container !== undefined) {
                            container.innerHTML = svg
                        }
                    })
                }, 1)
            }
        }

        let animateAFADBeaconTimer = undefined

        const animateAFADBeacon = (off) => {

            animateAFADBeaconTimer = setTimeout(() => {

                const beacon = document.getElementById("afadBeaconBottom")

                if (beacon !== null) {
                    if (off) {
                        beacon.setAttribute("fill", "#555")
                    } else {
                        beacon.setAttribute("fill", "#FFD300")
                    }
                    animateAFADBeacon(!off)
                }

            }, 750)
        }

        const AFAD_BEACON_STATE = {
            ArmDownBeaconRed:    0,
            ArmUpBeaconOff:      1,
            ArmUpBeaconSolid:    2,
            ArmUpBeaconFlashing: 3
        }

        const updateAFADDisplay = () => {

            if ($scope.tracker.meta.isTrackerAFADGate) {

                if (animateAFADBeaconTimer !== undefined) {
                    clearTimeout(animateAFADBeaconTimer)
                    animateAFADBeaconTimer = undefined
                }

                const armUp        = document.getElementById("afadArmUp")
                const armDown      = document.getElementById("afadArmDown")
                const beaconTop    = document.getElementById("afadBeaconTop")
                const beaconBottom = document.getElementById("afadBeaconBottom")

                if (armUp !== null && armDown !== null && beaconTop !== null && beaconBottom !== null) {

                    armUp.setAttribute("fill", "#555")
                    armDown.setAttribute("fill", "#55555500")
                    beaconTop.setAttribute("fill", "#555")
                    beaconBottom.setAttribute("fill", "#555")

                    if ($scope.tracker.telemetry.arm_beacon_state === AFAD_BEACON_STATE.ArmDownBeaconRed) {

                        armUp.setAttribute("fill", "#55555500")
                        armDown.setAttribute("fill", "#555")
                        beaconTop.setAttribute("fill", "#FF1807")

                    } else if ($scope.tracker.telemetry.arm_beacon_state === AFAD_BEACON_STATE.ArmUpBeaconSolid) {

                        beaconBottom.setAttribute("fill", "#FFD300")

                    } else if ($scope.tracker.telemetry.arm_beacon_state === AFAD_BEACON_STATE.ArmUpBeaconFlashing) {

                        beaconBottom.setAttribute("fill", "#FFD300")
                        animateAFADBeacon(true)

                    }
                }
            }
        }

        /**
            Get devices, tracker, and tracker telemetry history
         **/
        let dataRetrieve = []
        const gotData = () => {

            if (dataRetrieve.indexOf(false) === -1) {

                $scope.retrievedTracker = true
                updateDisplay()
                $scope.loading = false

            }
        }

        dataRetrieve.push(false)
        devicesService.getDeviceSummaries((deviceSummaries) => {

            const summaries = []

            for (const device of deviceSummaries) {
                if (device !== null && device !== undefined) {
                    summaries.push(device)
                }
            }

            $scope.deviceSummaries = summaries

            dataRetrieve[dataRetrieve.indexOf(false)] = true
            gotData()

        })

        dataRetrieve.push(false)
        trackersService.getTracker($stateParams.tracker_id, (data) => {
            $scope.tracker = data

            $rootScope.isWancoDevice = $scope.tracker.meta.isWancoDevice
            $rootScope.trackerName = data.name

            dataRetrieve[dataRetrieve.indexOf(false)] = true
            gotData()
        })

        dataRetrieve.push(false)
        historyService.getGPSHistory("Tracker", $stateParams.tracker_id, "", "", 1, $scope.gpsHistoryMaxRecords).then((data) => {

            $scope.gpsHistory = data

            dataRetrieve[dataRetrieve.indexOf(false)] = true
            gotData()

        })

        $scope.toggleBreadCrumbs = () => {

            $scope.showBreadCrumbs = !$scope.showBreadCrumbs
            updateBreadCrumbs()
            prefs.set(prefs.selectors().tracker.showBreadcrumbs, $scope.showBreadCrumbs)

        }

        $scope.setRequesting = (value) => {
            $scope.isRequesting = value
        }

        /**
            Datepicker config
         **/

        $scope.bcFilter = {
            fromDate: {
                value: undefined,
                isOpen: false,
                format: "yyyy-MM-dd",
                options: {
                    formatYear:  "yy",
                    startingDay: 1,
                    showWeeks:   false,
                    maxDate:     new Date()
                }
            },
            toDate: {
                value: undefined
            },
            duration: "7",
            allowApply: true,
            isApplied: false
        }

        $scope.openBcFromDate = () => {
            $scope.bcFilter.fromDate.isOpen = true
        }

        $scope.bcClearFilter = () => {

            $scope.bcFilter.fromDate.value = undefined
            $scope.bcFilter.isApplied = false
            updateBreadCrumbs()

        }

        $scope.bcChangeFilter = () => {

            $scope.bcCalculateToDate()

            if ($scope.bcFilter.isApplied && $scope.bcFilter.fromDate.value === undefined) {

                $scope.bcClearFilter()

            }

            $scope.bcFilter.isApplied = false

        }

        $scope.bcCalculateToDate = () => {

            $scope.bcFilter.toDate.value = undefined

            if ($scope.bcFilter.fromDate.value !== undefined && $scope.bcFilter.fromDate.value !== null) {

                let days = Number($scope.bcFilter.duration)
                let seconds = $scope.bcFilter.fromDate.value.getTime() + (days * 24 * 60 * 60 * 1000)
                $scope.bcFilter.toDate.value = new Date(seconds)


            } else {

                $scope.bcFilter.fromDate.value = undefined

            }
        }

        $scope.bcApplyFilter = () => {

            $scope.bcCalculateToDate()

            if ($scope.bcFilter.fromDate.value === undefined) {

                $scope.bcClearFilter()

            } else if ($scope.bcFilter.allowApply) {

                $scope.bcFilter.isApplied = true

                $scope.bcFilter.allowApply = false

                historyService.getGPSHistory("Tracker", $stateParams.tracker_id, $scope.bcFilter.fromDate.value, $scope.bcFilter.toDate.value, 1, $scope.gpsHistoryMaxRecords).then((data) => {

                    $scope.gpsHistoryFiltered = data
                    updateBreadCrumbs()
                    $scope.bcFilter.allowApply = true

                })
            }
        }

        /**
            Edit tracker geofence
         **/
        $scope.editTrackerGeofence = () => {
            $scope.submitted = true
            if ($scope.editGeofenceForm.$valid) {

                const success = (data) => {
                    gtag("event", "create_geofence", { action: "complete", device_id: $scope.tracker.device.id })

                    $scope.tracker.gps.geofence_center_lat = $scope.geofenceFormData.geofence_center_lat
                    $scope.tracker.gps.geofence_center_lon = $scope.geofenceFormData.geofence_center_lon
                    $scope.tracker.gps.geofence_radius     = $scope.geofenceFormData.geofence_radius
                    $scope.tracker.gps.geofence_units      = $scope.geofenceFormData.geofence_units

                    $state.go($state.$current, null, { reload: true }).then(() => {
                        userMessagingService.success("Geofence Edit Successful")
                        updateDisplay()
                    })
                }

                const failure = (error) => {
                    userMessagingService.error(error)
                }

                trackersService.editTracker($stateParams.tracker_id, angular.fromJson($scope.geofenceFormData), success, failure)
                $scope.editGeofence = false
            }
        }

        $scope.addGeofence = () => {
            $scope.geofenceFormData.geofence_center_lat = $filter("number")($scope.tracker.gps.lat || 0, 4)
            $scope.geofenceFormData.geofence_center_lon = $filter("number")($scope.tracker.gps.lon || 0, 4)
            $scope.geofenceFormData.geofence_radius = 0.5
            $scope.geofenceFormData.geofence_units = "mi"
        }

        $scope.toggleEditGeofence = () => {
            gtag("event", "create_geofence", { action: $scope.editGeofence ? "cancel" : "begin", device_id: $scope.tracker.device.id })
            $scope.editGeofence = !$scope.editGeofence
        }

        /**
            Center geofence
         **/
        $scope.centerGeofence = () => {
            $scope.geofenceFormData.geofence_center_lat = $filter("number")($scope.tracker.gps.lat || 0, 4)
            $scope.geofenceFormData.geofence_center_lon = $filter("number")($scope.tracker.gps.lon || 0, 4)
        }

        $scope.setLightDivOpacityLevel = (lightLevel) => {
            return {
                opacity: (100 - lightLevel) / 100
            }
        }

        $scope.beaconTrailerScheduleAMPM = (tracker, schedule_time) => {
            const hour = Number($rootScope.presentDateTime(schedule_time, 'TimeHour', tracker.device.timezone_iana))
            return hour >= 12 ? "PM" : "AM"
        }

        $scope.refreshTelemetry = (tracker) => {

            if ($scope.tracker.meta.isAlwaysOn === true) {

                if (!$scope.isRequesting) {

                    $scope.setRequesting(true)

                    const success = () => {}

                    const failure = (error) => {
                        $scope.setRequesting(false)
                        userMessagingService.error(error)
                    }

                    telemetryService.refreshTelemetry(tracker.type, $stateParams.tracker_id, success, failure)

                }
            }
        }

        $scope.openSetDisplayModal = (purpose) => {

            if (!$scope.isRequesting && $scope.tracker.telemetry.switch_position !== 2) {

                if (!$scope.isBlankingDisplay && !$scope.isSettingCaution) {

                    const onStart = () => {
                        if (purpose == "blank") {
                            $scope.isBlankingDisplay = true
                        } else {
                            $scope.isSettingCaution = true
                        }
                    }

                    const onSuccess = () => {
                        gtag("event", "display_change", { action: "complete", device_id: $scope.tracker.device.id, pattern: purpose })

                        if (purpose === "blank") {
                            userMessagingService.success("Blank Display Request Sent")
                        } else {
                            userMessagingService.success("Set Caution Request Sent")
                        }
                    }

                    const onFailure = (error) => {
                        $scope.isBlankingDisplay = false
                        $scope.isSettingCaution  = false
                        userMessagingService.error(error)
                    }

                    $uibModal.open({
                        templateUrl: "app/modals/set-arrow-board-display.view.html",
                        controller: "SetArrowBoardDisplayController",
                        resolve: {
                            trackerID: () => {
                                return $stateParams.tracker_id
                            },
                            toBlankDisplay: () => {
                                return purpose === "blank"
                            },
                            inRemoteMode: () => {
                                return $scope.tracker.telemetry.switch_position === 3
                            },
                            onStart: () => {
                                return onStart
                            },
                            onSuccess: () => {
                                return onSuccess
                            },
                            onFailure: () => {
                                return onFailure
                            }
                        }
                    }).result.catch((res) => {
                        if (!(res === "cancel" || res === "escape key press")) {
                            throw res
                        }
                    })
                }
            }
        }

        $scope.toggleBeaconTrailerBeaconOverride = () => {

            if (!$scope.isTogglingBeacons) {

                $scope.isTogglingBeacons = true

                const success = () => {
                    gtag("event", "display_change", { action: "complete", device_id: $scope.tracker.device.id, beacons: !$scope.tracker.telemetry.beacons_on })

                    let message = "On"
                    if ($scope.tracker.telemetry.beacons_on) {
                        message = "Off"
                    }
                    userMessagingService.success("Turn Beacons " + message + " Request Sent")
                }

                const failure = () => {

                    $scope.isTogglingBeacons = false

                    let message = "On"
                    if ($scope.tracker.telemetry.beacons_on) {
                        message = "Off"
                    }
                    userMessagingService.error("Failed to turn Beacons " + message + ". If this issue persists, please contact Wanco Support for assistance.")

                }

                trackersService.beaconTrailerSetBeaconOverride($stateParams.tracker_id, !$scope.tracker.telemetry.beacons_on, success, failure)

            }
        }

        $scope.openEditBeaconScheduleModal = () => {

            const onSuccess = (data) => {

                $scope.tracker = data
                updateDisplay()

            }

            const onFailure = (error) => {

                userMessagingService.error(error)

            }

            $uibModal.open({
                templateUrl: "app/modals/edit-beacon-schedule-modal.view.html",
                controller: "EditBeaconScheduleModalController",
                resolve: {
                    deviceID: () => $scope.tracker.device.id,
                    trackerID: () => $stateParams.tracker_id,
                    schedules: () => {
                        return {
                            schedule_start_time_1: $scope.tracker.beacon_trailer.schedule_start_time_1,
                            schedule_start_time_2: $scope.tracker.beacon_trailer.schedule_start_time_2,
                            schedule_end_time_1: $scope.tracker.beacon_trailer.schedule_end_time_1,
                            schedule_end_time_2: $scope.tracker.beacon_trailer.schedule_end_time_2,
                            schedule_active_1: $scope.tracker.beacon_trailer.schedule_active_1,
                            schedule_active_2: $scope.tracker.beacon_trailer.schedule_active_2,
                        }

                    },
                    timezoneIANA: () => {
                        return $scope.tracker.device.timezone_iana
                    },
                    onSuccess: () => {
                        return onSuccess
                    },
                    onFailure: () => {
                        return onFailure
                    }
                }
            }).result.catch((res) => {
                if (!(res === "cancel" || res === "escape key press")) {
                    throw res
                }
            })

        }

        $scope.openSetLightLevelsModal = () => {

            if (!$scope.isChangingLightLevels) {

                const onStart = () => {

                    $scope.isChangingLightLevels = true

                }

                const onSuccess = () => {

                    userMessagingService.success("Set Light Levels Request Sent")

                }

                const onFailure = (error) => {

                    $scope.isChangingLightLevels = false
                    userMessagingService.error(error)

                }

                $uibModal.open({
                    templateUrl: "app/modals/set-light-levels.view.html",
                    controller: "SetLightLevelsModalController",
                    resolve: {
                        deviceID: () => {
                            return $scope.tracker.device.id
                        },
                        trackerID: () => {
                            return $stateParams.tracker_id
                        },
                        light1TargetLevel: () => {
                            return $scope.tracker.solar_light_tower.light_1_active_level
                        },
                        light2TargetLevel: () => {
                            return $scope.tracker.solar_light_tower.light_2_active_level
                        },
                        light3TargetLevel: () => {
                            return $scope.tracker.solar_light_tower.light_3_active_level
                        },
                        light4TargetLevel: () => {
                            return $scope.tracker.solar_light_tower.light_4_active_level
                        },
                        duskToDawnActive: () => {
                            return $scope.tracker.solar_light_tower.dusk_to_dawn_active
                        },
                        localProgramActive: () => {
                            return $scope.tracker.solar_light_tower.local_program_active
                        },
                        setLightDivOpacityLevel: () => {
                            return $scope.setLightDivOpacityLevel
                        },
                        onStart: () => {
                            return onStart
                        },
                        onSuccess: () => {
                            return onSuccess
                        },
                        onFailure: () => {
                            return onFailure
                        }
                    }
                }).result.catch((res) => {
                    if (!(res === "cancel" || res === "escape key press")) {
                        throw res
                    }
                })
            }
        }

        $scope.openRestoreLocalControlModal = () => {

            if (!$scope.isChangingLightLevels && !$scope.isChangingMode) {

                const performRestoreLocal = () => {

                    const onSuccess = () => {

                        $scope.isChangingMode = false
                        userMessagingService.success("Restore Local Control Request Sent")

                    }

                    const onFailure = (error) => {

                        $scope.isChangingMode = false
                        userMessagingService.error(error)

                    }

                    $scope.isChangingMode = true

                    let trackerID = $stateParams.tracker_id
                    trackersService.solarLightTowerRestoreLocal(trackerID, onSuccess, onFailure)

                }

                $uibModal.open({
                    templateUrl: "app/modals/generic-confirmation-modal.view.html",
                    controller: "GenericConfirmationModalController",
                    resolve: {
                        title: () => {
                            return "Confirm Restore Local Control"
                        },
                        question: () => {
                            return "Are you sure you want to restore local control?"
                        },
                        warning: () => {
                            return "Any previous local settings will be reenabled."
                        },
                        buttonLabel: () => {
                            return "Restore"
                        },
                        performAction: () => {
                            return performRestoreLocal
                        }
                    }
                }).result.catch((res) => {
                    if (!(res === "cancel" || res === "escape key press")) {
                        throw res
                    }
                })
            }
        }

        $scope.openActivateDuskToDawnModal = () => {

            if (!$scope.isChangingLightLevels && !$scope.isChangingMode) {

                const performActivateDuskToDawn = () => {

                    const onSuccess = () => {

                        $scope.isChangingMode = false
                        userMessagingService.success("Activate Dusk to Dawn Request Sent")

                    }

                    const onFailure = (error) => {

                        $scope.isChangingMode = false
                        userMessagingService.error(error)

                    }

                    $scope.isChangingMode = true

                    let trackerID = $stateParams.tracker_id
                    trackersService.solarLightTowerActivateDuskToDawn(trackerID, onSuccess, onFailure)

                }

                $uibModal.open({
                    templateUrl: "app/modals/generic-confirmation-modal.view.html",
                    controller: "GenericConfirmationModalController",
                    resolve: {
                        title: () => {
                            return "Confirm Activate Dusk to Dawn"
                        },
                        question: () => {
                            return "Are you sure you want to activate Dusk to Dawn?"
                        },
                        warning: () => {
                            return "The current light levels may be changed."
                        },
                        buttonLabel: () => {
                            return "Activate"
                        },
                        performAction: () => {
                            return performActivateDuskToDawn
                        }
                    }
                }).result.catch((res) => {
                    if (!(res === "cancel" || res === "escape key press")) {
                        throw res
                    }
                })
            }
        }

        /**
            Watch for telemetry update
         **/

        $scope.$watch("$root.pushedData", (pushedData) => {

            if ($scope.tracker.hasOwnProperty("device")) {

                if (pushedData.hasOwnProperty("device") && pushedData.device.hasOwnProperty("device")) {

                    if (pushedData.device.device.id === $scope.tracker.device.id) {

                        $scope.setRequesting(false)
                        $scope.isChangingMode        = false
                        $scope.isChangingLightLevels = false
                        $scope.isTogglingBeacons     = false
                        $scope.isSettingCaution      = false
                        $scope.isBlankingDisplay     = false

                        const wasUserOwned = $scope.tracker.device.user_owned ? true : false
                        $scope.tracker = pushedData.device
                        $scope.tracker.device.user_owned = wasUserOwned

                        if (pushedData.device.hasOwnProperty("telemetry")) {
                            $scope.gpsHistory.unshift($scope.tracker.telemetry)
                        }

                        updateDisplay()

                        if (pushedData.hasOwnProperty("success")) {

                            userMessagingService.success(pushedData.success)

                        } else if (pushedData.hasOwnProperty("error")) {

                            userMessagingService.error(pushedData.error)

                        }
                    }

                } else if (!pushedData.reload && pushedData.hasOwnProperty("deviceID")) {

                    if (pushedData.deviceID === $scope.tracker.device.id) {

                        $scope.setRequesting(false)
                        $scope.isChangingLightLevels = false
                        $scope.isTogglingBeacons     = false
                        $scope.isSettingCaution      = false
                        $scope.isBlankingDisplay     = false

                        if (pushedData.hasOwnProperty("success")) {

                            userMessagingService.success(pushedData.success)

                        } else if (pushedData.hasOwnProperty("error")) {

                            userMessagingService.error(pushedData.error)

                        }
                    }
                }
            }
        })
    }
})()

const SOLAR_LIGHT_TOWER_STATUS_SVG = [
    '<svg width="574" height="304" viewBox="0 0 574 304" fill="none" xmlns="http://www.w3.org/2000/svg">',
    '',
    '    <rect x="1.5" y="1.5" width="233" height="118" rx="6.5" fill="#E5ECF3" stroke="#006BAF" stroke-width="3"/>',
    '    <path d="M0 8C0 3.58172 3.58172 0 8 0H228C232.418 0 236 3.58172 236 8V47H0V8Z" fill="#006BAF"/>',
    '    <text fill="white" font-family="sans-serif" font-size="24" font-weight="bold" x="118" y="33.2273" text-anchor="middle">SOLAR YIELD</text>',
    '    <text fill="black" font-family="sans-serif" font-size="39" font-weight="bold" x="118" y="96.6818" text-anchor="middle">---VSY--- W</text>',
    '',
    '    <g style="visibility: ---ACS1---;">',
    '        <rect x="236" y="58" width="72" height="5" fill="#909090"/>',
    '    </g>',
    '    <g style="visibility: ---ACS2---;">',
    '        <rect x="236" y="58" width="72" height="5" fill="#00971E"/>',
    '        <path d="M266.96 50.5355L279.179 60.435L275.96 63L266.96 50.5355Z" fill="#00971E"/>',
    '        <path d="M266.96 70.299L279.179 60.3995L275.96 58L266.96 70.299Z" fill="#00971E"/>',
    '        <path d="M252.56 50.5355L264.779 60.435L261.56 63L252.56 50.5355Z" fill="#00971E"/>',
    '        <path d="M252.56 70.299L264.779 60.3995L261.56 58L252.56 70.299Z" fill="#00971E"/>',
    '        <path d="M238.16 50.5355L250.379 60.435L247.16 63L238.16 50.5355Z" fill="#00971E"/>',
    '        <path d="M238.16 70.299L250.379 60.3995L247.16 58L238.16 70.299Z" fill="#00971E"/>',
    '        <path d="M281.36 50.5355L293.579 60.435L290.36 63L281.36 50.5355Z" fill="#00971E"/>',
    '        <path d="M281.36 70.299L293.579 60.3995L290.36 58L281.36 70.299Z" fill="#00971E"/>',
    '        <path d="M295.76 50.5355L307.979 60.435L304.76 63L295.76 50.5355Z" fill="#00971E"/>',
    '        <path d="M295.76 70.299L307.979 60.3995L304.76 58L295.76 70.299Z" fill="#00971E"/>',
    '    </g>',
    '',
    '    <rect x="309.5" y="1.5" width="193" height="255" rx="6.5" fill="#E5ECF3" stroke="#006BAF" stroke-width="3"/>',
    '    <path d="M308 8C308 3.58172 311.582 0 316 0H496C500.418 0 504 3.58172 504 8V47H308V8Z" fill="#006BAF"/>',
    '    <text fill="white" font-family="sans-serif" font-size="24" font-weight="bold" x="406" y="33.2273" text-anchor="middle">BATTERY</text>',
    '    <text fill="black" font-family="sans-serif" font-size="39" font-weight="bold" x="416" y="96.6818" text-anchor="middle">---VBP--- %</text>',
    '    <g style="visibility: ---CHG---;">',
    '        <text fill="#00971E" font-family="sans-serif" font-size="22" font-weight="bold" x="406" y="136.5" text-anchor="middle">CHARGING</text>',
    '    </g>',
    '    <text fill="black" font-family="sans-serif" font-size="20" font-weight="bold" x="430" y="166.273" text-anchor="end">---VBV---</text>',
    '    <text fill="black" font-family="sans-serif" font-size="20" font-weight="bold" x="443" y="166.273">V</text>',
    '    <text fill="black" font-family="sans-serif" font-size="20" font-weight="bold" x="430" y="191.273" text-anchor="end">---VBC---</text>',
    '    <text fill="black" font-family="sans-serif" font-size="20" font-weight="bold" x="443" y="191.273">A</text>',
    '    <text fill="black" font-family="sans-serif" font-size="20" font-weight="bold" x="430" y="216.273" text-anchor="end">---VBW---</text>',
    '    <text fill="black" font-family="sans-serif" font-size="20" font-weight="bold" x="443" y="216.273">W</text>',
    '    <text fill="black" font-family="sans-serif" font-size="20" font-weight="bold" x="430" y="241.273" text-anchor="end">---VBT---&#xb0;</text>',
    '    <text fill="black" font-family="sans-serif" font-size="20" font-weight="bold" x="443" y="241.273">C</text>',
    '',
    '    <g style="visibility: ---ACD1---;">',
    '        <rect width="72" height="5" transform="matrix(-1 0 0 1 308 195)" fill="#909090"/>',
    '    </g>',
    '    <g style="visibility: ---ACD2---;">',
    '        <rect width="72" height="5" transform="matrix(-1 0 0 1 308 195)" fill="#CD0101"/>',
    '        <path d="M277.04 187.536L264.821 197.435L268.04 200L277.04 187.536Z" fill="#CD0101"/>',
    '        <path d="M277.04 207.299L264.821 197.399L268.04 195L277.04 207.299Z" fill="#CD0101"/>',
    '        <path d="M291.44 187.536L279.221 197.435L282.44 200L291.44 187.536Z" fill="#CD0101"/>',
    '        <path d="M291.44 207.299L279.221 197.399L282.44 195L291.44 207.299Z" fill="#CD0101"/>',
    '        <path d="M305.84 187.536L293.621 197.435L296.84 200L305.84 187.536Z" fill="#CD0101"/>',
    '        <path d="M305.84 207.299L293.621 197.399L296.84 195L305.84 207.299Z" fill="#CD0101"/>',
    '        <path d="M262.64 187.536L250.421 197.435L253.64 200L262.64 187.536Z" fill="#CD0101"/>',
    '        <path d="M262.64 207.299L250.421 197.399L253.64 195L262.64 207.299Z" fill="#CD0101"/>',
    '        <path d="M248.24 187.536L236.021 197.435L239.24 200L248.24 187.536Z" fill="#CD0101"/>',
    '        <path d="M248.24 207.299L236.021 197.399L239.24 195L248.24 207.299Z" fill="#CD0101"/>',
    '    </g>',
    '',
    '    <rect x="1.5" y="138.5" width="233" height="118" rx="6.5" fill="#E5ECF3" stroke="#006BAF" stroke-width="3"/>',
    '    <path d="M0 145C0 140.582 3.58172 137 8 137H228C232.418 137 236 140.582 236 145V184H0V145Z" fill="#006BAF"/>',
    '    <text fill="white" font-family="sans-serif" font-size="24" font-weight="bold" x="118" y="170.227" text-anchor="middle">DC LOAD</text>',
    '    <text fill="black" font-family="sans-serif" font-size="39" font-weight="bold" x="118" y="233.682" text-anchor="middle">---VDL--- W</text>',
    '',
    '    <text fill="black" font-family="sans-serif" font-size="24" font-weight="bold" x="0" y="293.182" style="white-space: pre;">STATUS AS OF:  ---DATE---</text>',
    '',
    '</svg>'
].join()
